import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, Validators, FormControl, FormBuilder } from '@angular/forms';
import { UserService } from '../../services/user.service';
import { ToastrService } from 'ngx-toastr';
import { DataService } from 'src/app/services/data.service';
import { AuthService } from 'src/app/services/auth.service';

import { SocialAuthService, GoogleLoginProvider, SocialUser } from 'angularx-social-login';

declare var $: any

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  info: any;


  loginForm: FormGroup = new FormGroup({
    email: new FormControl('', [Validators.email, Validators.required]),
    pass: new FormControl('', [Validators.required, Validators.minLength(8), Validators.pattern(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9]).{8,}$/)])
  });
  get email() { return this.loginForm.get('email') }
  get pass() { return this.loginForm.get('pass') }

  constructor(
    private _router: Router,
    private _userService: UserService,
    private _authService: AuthService,
    private _toastr: ToastrService,
    private _dataService: DataService,
    private _socialAuthService: SocialAuthService
  ) {
    this.info = {
      passinfo: 'Password should contain First capital letter Password should be of min 8 length Password should contain at least special character and digit',
      email: 'Email is invalid'
    }
  }

  ngOnInit(): void {
    $('[data-toggle="tooltip"]').tooltip();
  }

  moveToRegister() {
    window.open("/register", "_self")
  }

  openHome(){
    window.open("/home","_self")
  }

  login() {

    this._authService.login(JSON.stringify(this.loginForm.value))
      .subscribe(

        (data: any) => {
          console.log(data);
          this._toastr.success("", data.msg)
          this.getProfile()
          this.openHome()
        },

        error => {
          console.error(error.error.msg);
          this._toastr.error("", error.error.msg)
        }
      )
  }

  signOut() {
    this._socialAuthService.signOut()
  }

  loginWithGoogle() {

    this._socialAuthService.signIn(GoogleLoginProvider.PROVIDER_ID).then(
      (user: SocialUser) => {
        const token = user.idToken
        const email = user.email
        const username = user.name

        this.signOut()

        this._authService.gsignin(JSON.stringify({
          token: token,
          username: username,
          email: email
        })).subscribe(
          (data: any) => {

            this._toastr.success("", data.msg)
            this.getProfile()
            this.openHome()
          },
          (error: any) => {

            console.error(error.error);
            this._toastr.error("", error.error.msg)
          }
        )
      }
    )
  }

  getProfile() {
    this._userService.profile().subscribe(
      (data: any) => {
        this._dataService.changeUsername(data.username || "")
        this._dataService.changeWallet(data.wallet || "0")
        this._dataService.toggleIsLoggedIn(true)
      }
    )
  }
}
